<template>
	<div class="exchange-rate">
		<icon 
			v-if="enableLoading && exchangeRatios.isLoading"
			loading
			v-tooltip
			data-toggle="tooltip"
			data-placement="top"
			:title="$translate('Eros::Template.calculating')"
		></icon>
		<template v-if="calculatedValue">
			{{ calculatedValue }}
		</template>
		<slot v-else></slot>
	</div>
</template>

<script>
import { mapState } from "vuex";

export default {
    name: "exchange-rate",

	props: {
		originValue: {
			type: Number,
			required: true
		},
		originCurrency: {
			type: String,
			default: "EUR"
		},
		customTargetCurrency: {
			type: String,
			default: ""
		},
		enableLoading: {
			type: Boolean,
			default: false
		},
		currencyFormat: {
			type: String,
			default: ""
		},
		customPattern: {
			type: String,
			default: ""
		},
		removeEuroWhitespace: {
			type: Boolean,
			default: false
		}
	},
	computed: {
		calculatedValue() {
			let calculatedValue = false;

			if (this.originCurrency === this.targetCurrency) {
				calculatedValue = this.$options.filters.currency(
					this.originValue,
					this.targetCurrency,
					this.currencyFormat,
					this.customPattern
				);
			} else if (
				!this.exchangeRatios.isLoading &&
				this.targetCurrency !== false &&
				this.targetExchangeRatio !== false &&
				this.originExchangeRatio !== false
			) {
				calculatedValue = this.$options.filters.currency(
					this.originValue / this.originExchangeRatio * this.targetExchangeRatio,
					this.targetCurrency,
					this.currencyFormat,
					this.customPattern
				);
			}

			if (typeof calculatedValue === "string" && this.removeEuroWhitespace) {
				return calculatedValue.replace(String.fromCharCode(160) + "€", "€");
			}

			return calculatedValue;
		},
		targetCurrency() {
			if (this.customTargetCurrency.length === 3) {
				return this.customTargetCurrency;
			} else if (typeof this.currentCurrency === "string" && this.currentCurrency.length === 3) {
				return this.currentCurrency;
			} 

			return false;
		},
		originExchangeRatio() {
			if (typeof this.exchangeRatios?.data[this.originCurrency] !== 'undefined') {
				return this.exchangeRatios.data[this.originCurrency];
			}

			return false;
		},
		targetExchangeRatio() {
			if (this.targetCurrency !== false &&
				typeof this.exchangeRatios?.data[this.targetCurrency] !== 'undefined'
			) {
				return this.exchangeRatios.data[this.targetCurrency];
			}

			return false;
		},
		...mapState({
			currentCurrency: (state) => state.basket.data.currency,
			exchangeRatios: (state) => state.exchangeRatios
		})
	},
	mounted() {
		if (!this.exchangeRatios.isRequested) {
			this.$store.dispatch("getExchangeRatios");
		}
	}
};
</script>